import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { DEFAULTS, GlobalSettingsState, loadSettings, saveSettings } from "./settingsPersistence";

interface GlobalSettingsContextValue {
  settings: GlobalSettingsState;
  updateSettings: (patch: Partial<GlobalSettingsState>) => void;
}

const GlobalSettingsContext = createContext<GlobalSettingsContextValue>({
  settings: DEFAULTS,
  updateSettings: () => {},
});

export const GlobalSettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [settings, setSettings] = useState<GlobalSettingsState>(loadSettings);

  useEffect(() => {
    saveSettings(settings);
  }, [settings]);

  const updateSettings = useCallback((patch: Partial<GlobalSettingsState>) => {
    setSettings((previous) => ({ ...previous, ...patch }));
  }, []);

  return (
    <GlobalSettingsContext.Provider value={{ settings, updateSettings }}>
      {children}
    </GlobalSettingsContext.Provider>
  );
};

export const useGlobalSettings = () => useContext(GlobalSettingsContext);
